export default __webpack_public_path__ + "static/media/background-home.775e24e1.svg";